import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { WaveLoading } from "react-loadingg";
import { IoClose } from "react-icons/io5";

import "./finance-style.scss";

export default function AddFinanceModel({
  show,
  setShow,
  type = "add",
  data,
  options,
  changeHandler,
  userDebounce,
  addTransaction,
  error,
  loaderAdd,
}) {
  return (
    <Modal show={show} contentClassName="add-finance-style">
      <Modal.Header className="font-14-700">
        {type == "add" ? "افزودن تراکنش" : ""}
        <div
          className="cursor-pointer"
          onClick={() => {
            setShow(false);
          }}
        >
          <IoClose
            className="wh-24 text-secondary pointer"
            color={"darkgray"}
          />
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex flex-wrap">
        <div className="m-1 col-4 flex-grow-1">
          <label className="label-style">نوع تراکنش</label>
          <Select
            options={options?.transaction_type}
            value={options?.transaction_type?.find(
              (v) => v?.value == data?.type
            )}
            onChange={(e) => {
              changeHandler({ type: e?.value });
            }}
          />
        </div>
        <div className="m-1 col-7 flex-grow-1">
          <label className="label-style">کارت بانکی</label>
          <Select
            options={options?.bank_account}
            value={options?.bank_account?.find(
              (v) => v?.value == data?.bank_account_id
            )}
            onChange={(e) => {
              changeHandler({ bank_account_id: e?.value });
            }}
          />
          <div className="validation-style">{error?.bank_account}</div>
        </div>
        <div className="m-1 col-4 flex-grow-1">
          <label className="label-style">
            مبلغ
            <span className="font-10-500">(تومان)</span>
          </label>
          <input
            className="form-control input-style"
            value={addCommas(data?.amount)}
            onChange={(e) => {
              if (!isNaN(removeCommas(e.target.value))) {
                changeHandler({ amount: removeCommas(e.target.value) });
              }
            }}
            onBlur={() => {
              if (data?.amount == "") {
                changeHandler({ amount: 0 });
              }
            }}
            onFocus={(e) => {
              if (data?.amount == 0) {
                changeHandler({ amount: "" });
              }
            }}
          />
          <div className="validation-style">{error?.amount}</div>
        </div>
        <div className="m-1 col-7 flex-grow-1">
          <label className="label-style">طرف حساب</label>
          <Select
            options={options?.users_options}
            value={data?.account_party_id}
            onChange={(e) => {
              changeHandler({
                account_party_id: e,
                newUserFname: "",
                newUserLname: "",
                newUserMobile: "",
              });
            }}
            onInputChange={(value) => {
              if (value != "") {
                userDebounce(value);
              }
            }}
          />
          <div className="validation-style">{error?.account_party}</div>
        </div>
        {data?.account_party_id?.value == -1 && (
          <div
            className="col-12 p-2 rounded-4 m-1 d-flex flex-wrap"
            style={{
              backgroundColor: "lightgray",
              border: "1px solid darkgray",
            }}
          >
            <div className="d-flex flex-column col-4 px-1">
              <label className="label-style">نام</label>
              <input
                className="form-control input-style"
                value={data?.newUserFname}
                onChange={(e) => {
                  changeHandler({ newUserFname: e?.target?.value });
                }}
              />
            </div>
            <div className="d-flex flex-column col-4 px-1">
              <label className="label-style">نام خانوادگی</label>
              <input
                className="form-control input-style"
                value={data?.newUserLname}
                onChange={(e) => {
                  changeHandler({ newUserLname: e?.target?.value });
                }}
              />
            </div>
            <div className="d-flex flex-column col-4 px-1">
              <label className="label-style">موبایل</label>
              <input
                className="form-control input-style"
                value={data?.newUserMobile}
                onChange={(e) => {
                  if (!isNaN(e?.target?.value)) {
                    changeHandler({ newUserMobile: e?.target?.value });
                  }
                }}
              />
            </div>
            <div className="validation-style col-12">
              {error?.account_party_new}
            </div>
          </div>
        )}
        <div className="m-1 col-4 flex-grow-1 d-flex flex-column">
          <label className="label-style">زمان انجام</label>
          <DatePicker
            containerClassName="date-picker"
            calendar={persian}
            locale={persian_fa}
            value={parseInt(data?.to_do_time) * 1000}
            id="add-finance-model"
            maxDate={new Date()}
            onChange={(e) => {
              console.log("object", e);
              changeHandler({ to_do_time: e?.unix });
            }}
          />
          <div className="validation-style">{error?.to_do_time}</div>
        </div>
        <div className="m-1 col-7 flex-grow-1">
          <label className="label-style">کد رهگیری</label>
          <input
            className="form-control input-style"
            value={data?.tracking}
            onChange={(e) => {
              if (!isNaN(e?.target?.value)) {
                changeHandler({ tracking: e.target.value });
              }
            }}
          />
          <div className="validation-style">{error?.tracking}</div>
        </div>
        <div className="m-1 flex-grow-1 col-12">
          <label className="label-style">توضیحات</label>
          <textarea
            className="form-control input-style"
            value={data?.description}
            onChange={(e) => {
              changeHandler({ description: e.target.value });
            }}
          />
        </div>
        <div className="m-1 flex-grow-1">
          <label className="label-style">فایل</label>
          <input
            type="file"
            className="form-control "
            onChange={(e) => {
              changeHandler({ file: e?.target?.files?.[0] });
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="font-14-500 px-5 py-2 position-relative"
          style={{ width: 120, minHeight: 40 }}
          variant="success"
          onClick={() => {
            addTransaction();
          }}
        >
          {loaderAdd ? (
            <div className="position-absolute" style={{ right: 12 }}>
              <WaveLoading color="white" size="small" />
            </div>
          ) : (
            <>ثبت</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
